import React from 'react'
import { motion } from 'framer-motion'

const testimonials = [
  {
    name: "Sarah Johnson",
    company: "Creative Designs Co.",
    text: "Vector Visionionary transformed our logo into a perfect vector format. The quality exceeded our expectations!",
    rating: 5,
  },
  {
    name: "Mike Chen",
    company: "Embroidery Plus",
    text: "Fast turnaround time and excellent digitization work. Highly recommended for embroidery files.",
    rating: 5,
  },
  {
    name: "Emily Rodriguez",
    company: "Patch Masters",
    text: "Outstanding custom patch designs. Professional service and great communication throughout.",
    rating: 5,
  },
  {
    name: "Daniel Carter",
    company: "Stitch & Thread Studio",
    text: "Our files stitched out clean on the first run. No thread breaks, no rework, and they were ready the same day.",
    rating: 5,
  },
  {
    name: "Priya Patel",
    company: "Brandwave Apparel",
    text: "They rebuilt our old brand artwork from a blurry sketch and delivered files that work on everything from hats to banners.",
    rating: 5,
  },
  {
    name: "Lucas Meyer",
    company: "Northline Uniforms",
    text: "We order digitized logos in bulk and the quality is consistent every time. Support answers fast and revisions are painless.",
    rating: 5,
  },
]

const bars = [
  "bg-orange-500",
  "bg-red-500",
  "bg-amber-500",
  "bg-rose-500",
  "bg-orange-500",
  "bg-amber-500",
]

const initials = (name) =>
  name
    .split(' ')
    .map((n) => n[0])
    .join('')

const ClientTestimonials = () => {
  return (
    <section className="relative overflow-hidden bg-white py-24 md:py-32">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 -left-32 h-96 w-96 rounded-full bg-orange-200/40 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-40 -right-32 h-96 w-96 rounded-full bg-amber-200/40 blur-3xl"
      />

      <div className="relative max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-14 md:mb-20 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-end"
        >
          <h2 className="text-5xl md:text-7xl font-extrabold tracking-tight leading-[1.02] text-slate-900">
            What Our{' '}
            <span className="bg-gradient-to-r from-orange-500 via-red-500 to-amber-500 bg-clip-text text-transparent">
              Clients Say
            </span>
          </h2>
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed">
            Don't just take our word for it. Here's what our satisfied clients have to say.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (index % 3) * 0.1 }}
              className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 pt-10 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-orange-300 hover:shadow-2xl hover:shadow-orange-100"
            >
              <div className={`absolute left-0 top-0 h-1.5 w-full ${bars[index % bars.length]}`} />

              <div
                aria-hidden="true"
                className="absolute right-6 top-4 select-none font-serif text-8xl leading-none text-orange-100 transition-colors duration-300 group-hover:text-orange-200"
              >
                &ldquo;
              </div>

              <div className="relative flex mb-5" role="img" aria-label={`${t.rating} out of 5 stars`}>
                {[...Array(t.rating)].map((_, i) => (
                  <svg key={i} className="w-5 h-5 text-amber-400" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              <blockquote className="relative text-lg leading-relaxed text-slate-700 mb-8">
                "{t.text}"
              </blockquote>

              <figcaption className="mt-auto flex items-center gap-4 border-t border-dashed border-slate-300 pt-6">
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-slate-900 text-sm font-bold text-white">
                  {initials(t.name)}
                </span>
                <span>
                  <span className="block font-semibold text-slate-900">{t.name}</span>
                  <span className="block text-sm text-slate-500">{t.company}</span>
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ClientTestimonials